import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { Link } from '@/navigation';
import type { Icon } from '@phosphor-icons/react';

interface Props {
  text: string;
  icon?: Icon;
  redirect: string;
  externalRoute?: boolean;
}

export const TextWithLeadingIcon = ({
  icon,
  text,
  redirect,
  externalRoute = false,
  ...rest
}: Props) => {
  return externalRoute ? (
    <a
      href={redirect}
      className="flex h-full items-center text-default no-underline transition-all hover:text-strong"
      {...rest}
    >
      <div className="flex w-full items-center gap-3 border-decorative border-b-1 transition-all hover:border-strong">
        {icon && (
          <PhosphorIcon
            Icon={icon}
            variant="bold"
            className="icon-s m:icon-xs"
          />
        )}
        <span className="m:text-small text-body">{text}</span>
      </div>
    </a>
  ) : (
    <Link
      href={redirect}
      className="flex h-full items-center text-default no-underline transition-all hover:text-strong"
      {...rest}
    >
      <div className="flex w-full items-center gap-3 border-decorative border-b-1 transition-all hover:border-strong">
        {icon && (
          <PhosphorIcon
            Icon={icon}
            variant="bold"
            className="icon-s m:icon-xs"
          />
        )}
        <span className="m:text-small text-body">{text}</span>
      </div>
    </Link>
  );
};
